// Файл navigation_setting_definitions.js

/**
 * Определяет разделы, доступные в персональных настройках навигации.
 * Здесь перечислены контекстные панели и режим прямого открытия
 * объектов, которые отображаются на вкладке настроек интерфейса.
 */

export const contextual_navigation_sections = [
    {
        key: 'houses_and_communal_service',
        label: 'ЖКУ',
    },
    {
        key: 'document_management',
        label: 'Документооборот',
    },
    {
        key: 'personnel_and_salary',
        label: 'Кадры и зарплата',
    },
    {
        key: 'taxes_and_tax_reporting',
        label: 'Налоги',
    },
    {
        key: 'accounting_and_reporting',
        label: 'Бухучёт и отчётность',
    },
    {
        key: 'app_settings',
        label: 'Настройки',
    },
];

export const direct_object_sections = [
    ['management_objects_1', 'Объекты управления'],
    ['personnel_entities_table', 'Кадры и зарплата'],
    ['management_objects_residents', 'Жители'],
    [
        'meetings_management_objects',
        'Собрания и голосования',
    ],
    ['management_objects_3', 'ЖКУ'],
    ['management_objects_4', 'Начисления и оплаты'],
    ['purchases_and_sales_objects', 'Покупки и продажи'],
    ['cash_receipts_objects', 'Кассовые чеки'],
    [
        'register_bank_accounts',
        'Банковские счета и выписки',
    ],
    ['accounting_objects', 'Бухучёт и отчётность'],
    ['management_objects_taxes', 'Налоги и отчётность'],
    ['management_objects_7', 'Документооборот'],
    [
        'management_objects_document_showcase',
        'Витрина документов',
    ],
].map(([key, label]) => ({ key, label }));

export const navigation_setting_groups = [
    {
        key: 'contextual_navigation',
        label: 'Контекстная левая панель',
        sections: contextual_navigation_sections,
    },
    {
        key: 'direct_object_mode',
        label: 'Открывать объект без ' + 'таблицы объектов',
        sections: direct_object_sections,
    },
];

export const create_default_navigation_settings = () => (
    Object.fromEntries(
        navigation_setting_groups.map((group) => [
            group.key,
            Object.fromEntries(
                group.sections.map((section) => [section.key, false])
            ),
        ])
    )
);
